/**
 * Форматирование чисел
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {string}
 */
window.number_format = function (number, decimals = 0, dec_point = '.', thousands_sep = ',') {
	let sign = number < 0 ? '-' : '';

	let s_number = Math.abs(parseInt(number = (+number || 0).toFixed(decimals))) + "";
	let len = s_number.length;
	let tchunk = len > 3 ? len % 3 : 0;

	let ch_first = (tchunk ? s_number.substr(0, tchunk) + thousands_sep : '');
	let ch_rest = s_number.substr(tchunk)
	.replace(/(\d\d\d)(?=\d)/g, '$1' + thousands_sep);
	let ch_last = decimals ?
		dec_point + (Math.abs(number) - s_number)
		.toFixed(decimals)
		.slice(2) : '';

	return sign + ch_first + ch_rest + ch_last;
};

/**
 * Форматирование денег
 * @param money
 * @param sign
 * @returns {string}
 */
window.output_money = function (money, sign = 'р') {
	return number_format(money, 0, ' ', ' ') + ' ' + sign;
};

/**
 * Рандомная строка
 * @param length
 * @returns {string}
 */
window.str_random = function (length) {
	let result           = '';
	let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let charactersLength = characters.length;
	for ( let i = 0; i < length; i++ ) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}

	return result;
};

/**
 * Консоль
 * @param type
 * @param arr
 * @returns {boolean}
 * @constructor
 */
window.VGLog = function (type, arr = []) {
	if (!type) return false;

	switch (type) {
		case 'error':
			arr.forEach(function (item) {
				console.error(item);
			});
			break;
		case 'debug':
			arr.forEach(function (item) {
				console.debug(item);
			});
			break;
		case 'success':
			if (arr.length) {
				arr.forEach(function (item) {
					console.log("%c" + item, "color: green;");
				});
			}
			break;
		default:
			console.log(type);
			break;
	}
}